import Textarea from "@src/components/form/input/Textarea";
import { removeAlert } from "@store/app/app-actions";
import { AppState } from "@store/reducers";
import i18next from "i18next";
import React, { useState } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { getIconClass } from "./alert-utils";
import "./alert.scss";

interface Props extends RouteComponentProps {
    alerts: AppState["app"]["alerts"];
    removeAlert(id: string): void;
}

const Alert = (props: Props) => {
    const [formMessage, setFormMessage] = useState({text: ""});
    const [loading, setLoading] = useState(false);

    const alert = props.alerts[0];

    if (!alert) {
        return null;
    }

    const { type, id, title, message, onClose, onConfirm, goBackOnClose, loadingMessage} = alert;
    const icon = getIconClass(type);

    const handleClose = () => {
        props.removeAlert(id);
        onClose && onClose();
        goBackOnClose && props.history.back();
    };

    const handleConfirm = async () => {
        setLoading(true);
        if (onConfirm) await onConfirm(formMessage.text);
        setLoading(false);

        props.removeAlert(id);
    };

    return (
        <div className={`Alert__container ${loading ? "__isLoading" : ""}`}>
            <div className={`Alert Alert--${type}`}>
                <i className={`Alert__icon ${icon}`}></i>
                <h2 className="Alert__title">{title || type}</h2>
                {!loading &&
                    <i className="Alert__close cinicon-cross" onClick={handleClose}></i>
                }
                <p className="Alert__content">{loading ? loadingMessage : message}</p>
                <div className="FormField FormField--text">
                </div>
                {type === "confirm" && (
                    loading ? (
                        <div className="Alert__loadingContainer">
                            <div className="Alert--spinner"></div>
                        </div>
                    ) : (
                        <div className="Alert__buttons">
                            <div className="Alert__confirmButton" onClick={handleConfirm}>
                                {i18next.t("translation::Confirm")}
                            </div>
                            <div className="Alert__cancelButton" onClick={handleClose}>
                                {i18next.t("translation::Cancel")}
                            </div>
                        </div>
                    )
                )}
                {type === "form" && (
                    <>
                        <div className="Alert__form-field">
                            <Textarea
                                maxCharacters={100}
                                resize={false}
                                value={formMessage.text}
                                onChange={(value: string) => setFormMessage({ text: value })}
                                placeholder={i18next.t("translation::Enter message")}
                            />
                        </div>
                         <div className="Alert__buttons">
                            <div className="Alert__confirmButton" onClick={handleConfirm}>{i18next.t("translation::Confirm")}</div>
                            <div className="Alert__cancelButton" onClick={handleClose}>{i18next.t("translation::Cancel")}</div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export const mapStateToProps = (state: AppState) => ({ alerts: state.app.alerts });
export const actions = { removeAlert };

export default withRouter(connect(mapStateToProps, actions)(Alert));
